(function () {
  var nav = document.querySelector('[data-collection-sticky-nav]');
  var header = document.getElementById('shopify-section-header');
  if (!nav || !header) return;

  var ticking = false;

  function updateOffset() {
    var bottom = Math.max(header.getBoundingClientRect().bottom, 0);
    nav.style.setProperty('--collection-nav-top', bottom + 'px');
    ticking = false;
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateOffset);
  }

  updateOffset();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
})();
